const tectonTheme = {
  colors: {
    tectonRed: `#DA4B35`,
  },
};

export default tectonTheme;
